<template>
  <div ref="formContainer">
    <user-table :users="users" :totalPages="totalPages" :page="page" @setPage="setPage" :setskeletonLoader="displayLoader"></user-table>
  </div>
</template>

<script>
  import helpers from '@/helpers.js';
  import UserTable from './user_table';
  import axios from 'axios';
  export default {
    components: {
      UserTable,
    },


    data: function () {
      return {
        page: 0,
        fullPage: '',
        organization_search: '',
        displayLoader: true,
      }
    },


    computed: {
      users: function () {
        return this.$store.getters['users/users'];
      },

      totalPages: function () {
        return this.$store.getters['users/totalPages'];
      }
    },


    created: function () {
      let page = helpers.get_query_string_by_key(this.$route.query, 'page');
      let organization_search = helpers.get_query_string_by_key(this.$route.query, 'organization_search');
      this.page = page ? page : 1;
      this.organization_search = organization_search ? organization_search : 'all';
    },


    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: 'dots',
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setskeletonLoader(true);
        this.$store.dispatch('users/get_master_users_list', [val, this.organization_search]).then(() => {
          setTimeout(() => {
          // loader.hide();
            this.setskeletonLoader(false);
          }, 1000);
          // loader.hide();
        });
      }
    },


    methods: {
      setPage(page, organization_search) {
        this.page = page;
        this.organization_search = organization_search;
        this.$router.push('master?page=' + page + '&organization_search=' + this.organization_search);
      },
      setskeletonLoader(event){
        this.displayLoader = event;
        this.$forceUpdate();
      },
    }
  }
</script>
<style>
  .custom_all {
    position: absolute;
    z-index: 999;
    top: 350px;
    left: 40%;
    opacity: 0.0.5;
  }
</style>